var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVerticalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "size=32px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9998 17.3333C16.7362 17.3333 17.3332 16.7364 17.3332 16C17.3332 15.2636 16.7362 14.6667 15.9998 14.6667C15.2635 14.6667 14.6665 15.2636 14.6665 16C14.6665 16.7364 15.2635 17.3333 15.9998 17.3333Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.9998 7.99999C16.7362 7.99999 17.3332 7.40304 17.3332 6.66666C17.3332 5.93028 16.7362 5.33333 15.9998 5.33333C15.2635 5.33333 14.6665 5.93028 14.6665 6.66666C14.6665 7.40304 15.2635 7.99999 15.9998 7.99999Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.9998 26.6667C16.7362 26.6667 17.3332 26.0697 17.3332 25.3333C17.3332 24.597 16.7362 24 15.9998 24C15.2635 24 14.6665 24.597 14.6665 25.3333C14.6665 26.0697 15.2635 26.6667 15.9998 26.6667Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVerticalIcon);
export default __webpack_public_path__ + "static/media/moreVerticalIcon.186dfd33997d6c2720710f7c716a400f.svg";
export { ForwardRef as ReactComponent };